import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col, Container } from "react-bootstrap";
import AuthUser from "../../services/AuthUser";
import "./AgentSignupRequest.css";


const AgentSignupRequest = () => {
         const { http, token } = AuthUser();

    const [errors, setErrors] = useState({});


    const [formData, setFormData] = useState({
        name: "",
        fatherName: "",
        spouseName: "",
        dob: "",
        address: "",
        mobile1: "",
        mobile2: "",
        email: "",
        aadhar: "",
        pan: "",
        qualification: "",
        experienceYear: "",
        experienceMonth: "",
        pancard: null,
        adharcard: null,
        password: "",
        password_confirmation: "",
        profileType: "Agent",

    });

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [showMessage, setShowMessage] = useState(true);

    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setShowMessage(false);
            }, 3000); // 3 seconds

            return () => clearTimeout(timer);
        }
    }, [message]);

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;

        if (type === "file") {
            // Check if file exists
            if (files && files[0]) {

                setFormData((prev) => ({
                    ...prev,
                    [name]: files[0], // Store the actual file in state
                }));
            }
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value, // Update other fields normally
            }));
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setErrors({});

        if (formData.password !== formData.password_confirmation) {
            setErrors({ password_confirmation: "Passwords do not match." });
            return;
        }

        const form = new FormData();

        // Loop through formData to append all values
        Object.entries(formData).forEach(([key, value]) => {
            if (value instanceof File) {
                form.append(key, value); // Automatically handles any file field
            } else {
                form.append(key, value);
            }
        });


        // setLoading(true);
        try {
            // const form = new FormData();

            // Object.entries(formData).forEach(([key, value]) => {
            //     if (key === "resume" && value instanceof File) {
            //         form.append("resume", value);
            //     } else if (key !== "resume") {
            //         form.append(key, value);
            //     }
            // });

            // console.log("FormData before submission:");
            // for (let pair of form.entries()) {
            //     console.log(`${pair[0]}:`, pair[1]);
            // }




            const response = await http.post("/agent-signup-request", form, {
                headers: {
                    "Content-Type": "multipart/form-data", // ✅ Important
                },
            });



            setShowMessage(true);
            setMessage(response.data.message);
            setFormData({
                name: "",
                fatherName: "",
                spouseName: "",
                dob: "",
                address: "",
                mobile1: "",
                mobile2: "",
                email: "",
                aadhar: "",
                pan: "",
                qualification: "",
                experienceYear: "",
                experienceMonth: "",
                pancard: null,
                adharcard: null,
                password: "",
                password_confirmation: "",
                profileType: "Agent",
            });
        } catch (err) {
            if (err.response && err.response.data) {
                const data = err.response.data;

                // Set field validation errors if present
                if (data.errors) {
                    setErrors(data.errors);
                }

                // Show main error message
                setShowMessage(true);
                setMessage(data.message || "Something went wrong.");
            } else {
                setMessage("An unknown error occurred.");
            }
        }
    };

    return (
        <Container className="agent-form-wrapper d-flex justify-content-center align-items-center">
            <div className="agent-form w-100">

                <Form onSubmit={handleSubmit} encType="multipart/form-data">
                    <Row>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Name</Form.Label>
                                <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} required />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Father Name</Form.Label>
                                <Form.Control type="text" name="fatherName" value={formData.fatherName} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Spouse Name</Form.Label>
                                <Form.Control type="text" name="spouseName" value={formData.spouseName} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mt-2">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Date of Birth</Form.Label>
                                <Form.Control type="date" name="dob" value={formData.dob} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md={8}>
                            <Form.Group>
                                <Form.Label>Address</Form.Label>
                                <Form.Control as="textarea" rows={2} name="address" value={formData.address} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mt-2">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Mobile No. 1</Form.Label>
                                <Form.Control type="text" name="mobile1" value={formData.mobile1} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Mobile No. 2</Form.Label>
                                <Form.Control type="text" name="mobile2" value={formData.mobile2} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} required />
                            </Form.Group>
                        </Col>
                    </Row>

                   

                    <Row className="mt-2">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Aadhar</Form.Label>
                                <Form.Control type="text" name="aadhar" value={formData.aadhar} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>PAN</Form.Label>
                                <Form.Control type="text" name="pan" value={formData.pan} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Qualification</Form.Label>
                                <Form.Select name="qualification" value={formData.qualification} onChange={handleChange}>
                                    <option value="">Select...</option>
                                    <option>High School</option>
                                    <option>Higher Secondary</option>
                                    <option>Graduate</option>
                                    <option>Post Graduate</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mt-2">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Experience (Years)</Form.Label>
                                <Form.Control type="number" name="experienceYear" value={formData.experienceYear} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Experience (Months)</Form.Label>
                                <Form.Control type="number" name="experienceMonth" value={formData.experienceMonth} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>PAN Card</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="pancard"
                                    accept=".pdf,.doc,.docx,image/*"
                                    onChange={handleChange} // Ensure this is the correct function
                                />
                            </Form.Group>

                        </Col>
                       
                    </Row>
                    <Row className="mt-2">
                    <Col md={4}>
                            <Form.Group>
                                <Form.Label>Adhar Card</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="adharcard"
                                    accept=".pdf,.doc,.docx,image/*"
                                    onChange={handleChange} // Ensure this is the correct function
                                />
                            </Form.Group>

                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="password_confirmation"
                                    value={formData.password_confirmation}
                                    onChange={handleChange}
                                    required
                                    isInvalid={!!errors.password_confirmation}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.password_confirmation}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>




                    {showMessage && (
                        <p className="mt-3 text-infoo fade-out">{message}</p>
                    )}

                    <Button type="submit" variant="primary" className="mt-4 w-100" disabled={loading}>
                        {loading ? "Submitting..." : "Submit Request"}
                    </Button>
                </Form>
            </div>
        </Container>
    );
};

export default AgentSignupRequest;
